import { SystemConfigForm } from './SystemConfigForm'
import { SYS_STR as S } from './systemConfigApi'

/**
 * A24.02–A24.04 / A24.07 / A24.09 — platform-wide infra CONFIG forms. Each field
 * is a real app_settings key read/written via `/admin/settings/system` (fail-soft
 * until the backend struct lists the key). Grouped like `developers/*Screens.tsx`.
 */

/** A24.02 — Brending (logo, ranglar). */
export function BrandingSettings() {
  return (
    <SystemConfigForm
      screenId="A24.02"
      title={S.brandingTitle}
      description={S.brandingDesc}
      sections={[
        {
          title: S.secBrandIdentity,
          fields: [
            { key: 'brand_app_name', label: S.fAppName, def: 'MyGram' },
            { key: 'brand_logo_url', label: S.fLogoUrl, mono: true, placeholder: 'https://…' },
            { key: 'brand_logo_dark_url', label: S.fLogoDarkUrl, mono: true, placeholder: 'https://…' },
            { key: 'brand_favicon_url', label: S.fFaviconUrl, mono: true, placeholder: 'https://…' },
          ],
        },
        {
          title: S.secBrandColors,
          fields: [
            { key: 'brand_primary_color', label: S.fPrimaryColor, type: 'color', def: '#2f6fed' },
            { key: 'brand_accent_color', label: S.fAccentColor, type: 'color', def: '#0a84ff' },
          ],
        },
      ]}
    />
  )
}

/** A24.03 — Domenlar konfiguratsiyasi. */
export function DomainsSettings() {
  return (
    <SystemConfigForm
      screenId="A24.03"
      title={S.domainsTitle}
      description={S.domainsDesc}
      sections={[
        {
          fields: [
            { key: 'domain_api', label: S.fApiDomain, mono: true, placeholder: 'api.example.com' },
            { key: 'domain_web', label: S.fWebDomain, mono: true, placeholder: 'app.example.com' },
            { key: 'domain_ws', label: S.fWsDomain, mono: true, placeholder: 'ws.example.com' },
            { key: 'domain_cdn', label: S.fCdnDomain, mono: true, placeholder: 'cdn.example.com' },
            { key: 'domain_media', label: S.fMediaDomain, mono: true, placeholder: 'media.example.com' },
          ],
        },
      ]}
    />
  )
}

/** A24.04 — Email sozlamalari (SMTP). */
export function SmtpSettings() {
  return (
    <SystemConfigForm
      screenId="A24.04"
      title={S.smtpTitle}
      description={S.smtpDesc}
      sections={[
        {
          title: S.secSmtpServer,
          fields: [
            { key: 'smtp_host', label: S.fSmtpHost, mono: true, placeholder: 'smtp.example.com' },
            { key: 'smtp_port', label: S.fSmtpPort, type: 'number', def: '587', min: 1, max: 65535, mono: true },
            { key: 'smtp_user', label: S.fSmtpUser, mono: true },
            { key: 'smtp_password', label: S.fSmtpPass, type: 'password', secret: true },
            {
              key: 'smtp_tls',
              label: S.fSmtpTls,
              type: 'select',
              def: 'starttls',
              options: [
                { value: 'none', label: 'None' },
                { value: 'starttls', label: 'STARTTLS' },
                { value: 'ssl', label: 'SSL/TLS' },
              ],
            },
          ],
        },
        {
          title: S.secSmtpSender,
          fields: [
            { key: 'smtp_from', label: S.fSmtpFrom, mono: true, placeholder: 'no-reply@example.com' },
            { key: 'smtp_from_name', label: S.fSmtpFromName, def: 'MyGram' },
          ],
        },
      ]}
    />
  )
}

/** A24.07 — Fayl saqlash sozlamalari. */
export function FileStorageSettings() {
  return (
    <SystemConfigForm
      screenId="A24.07"
      title={S.storageTitle}
      description={S.storageDesc}
      sections={[
        {
          fields: [
            {
              key: 'storage_provider',
              label: S.fStorageProvider,
              type: 'select',
              def: 'minio',
              options: [
                { value: 'minio', label: 'MinIO' },
                { value: 's3', label: 'Amazon S3' },
                { value: 'gcs', label: 'Google Cloud Storage' },
                { value: 'local', label: 'Local disk' },
              ],
            },
            { key: 'storage_bucket', label: S.fStorageBucket, mono: true },
            { key: 'storage_region', label: S.fStorageRegion, mono: true, placeholder: 'us-east-1' },
            { key: 'storage_endpoint', label: S.fStorageEndpoint, mono: true, placeholder: 'https://…' },
            { key: 'storage_max_mb', label: S.fStorageMaxMb, type: 'number', def: '50', min: 1, mono: true },
          ],
        },
      ]}
    />
  )
}

/** A24.09 — Qidiruv indeksi. */
export function SearchIndexSettings() {
  return (
    <SystemConfigForm
      screenId="A24.09"
      title={S.searchTitle}
      description={S.searchDesc}
      sections={[
        {
          fields: [
            { key: 'search_enabled', label: S.fSearchEnabled, type: 'bool', def: 'true' },
            {
              key: 'search_provider',
              label: S.fSearchProvider,
              type: 'select',
              def: 'postgres',
              options: [
                { value: 'postgres', label: 'PostgreSQL (tsvector)' },
                { value: 'meilisearch', label: 'Meilisearch' },
                { value: 'elasticsearch', label: 'Elasticsearch' },
                { value: 'typesense', label: 'Typesense' },
              ],
            },
            { key: 'search_index', label: S.fSearchIndex, mono: true, def: 'grom' },
            { key: 'search_host', label: S.fSearchHost, mono: true, placeholder: 'http://…' },
            { key: 'search_min_chars', label: S.fSearchMinChars, type: 'number', def: '2', min: 1, max: 10, mono: true },
          ],
        },
      ]}
    />
  )
}
